import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit{

  constructor() {

  }
  ngOnInit(): void {
    console.log('AppComponent init');
  }
  title = 'maria-ewc-ng';
}
